import { shouldFlipUp } from './should-flip-up';

interface Bounds {
  top: number;
  bottom: number;
}

export interface FlipUpOffsetParams {
  anchor: Bounds;
  panel: Bounds;
  boundary: Bounds;
}

/** Pixels to lift the panel by so it sits above its anchor, or 0 when it should stay below. */
export const getFlipUpOffset = ({ anchor, panel, boundary }: FlipUpOffsetParams): number => {
  if (!shouldFlipUp({ anchor, panel, boundary })) {
    return 0;
  }
  return Math.round(panel.bottom - anchor.top);
};
